import { defineAsyncComponent } from 'vue'
export default {
  authenticated: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/authenticated.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m))
}